import React, { useEffect, useState } from 'react';

import { useFetchHubByAddress } from '../../hooks/useFetchHubByAddress';
import { useLocalize } from '../../hooks/useLocalize';
import { useResolveGoogleAddress } from '../../hooks/useResolveGoogleAddress';
import { ReactComponent as IndicatorOneWay } from './indicator-one-way.svg';
import { ReactComponent as IndicatorRoundtrip } from './indicator-roundtrip.svg';
import styles from './JourneyInfoCondensed.module.scss';
import { ReactComponent as PenIcon } from './pen.svg';

interface JourneyInfoCondensedProps {
  roundtrip: boolean;
  onClick: () => void;
  origin: string;
  destination: string;
  isOutbound: boolean;
}

export const JourneyInfoCondensed: React.FC<JourneyInfoCondensedProps> = ({
  roundtrip,
  onClick,
  origin,
  destination,
  isOutbound,
}) => {
  const { translate: t, locale } = useLocalize();
  const Icon = roundtrip ? IndicatorRoundtrip : IndicatorOneWay;
  const getHubByAddress = useFetchHubByAddress(locale);
  const resolveGoogleAddress = useResolveGoogleAddress();

  const [formattedOrigin, setFormattedOrigin] = useState<string>(origin);
  const [formattedDestination, setFormattedDestination] = useState<string>(destination);

  useEffect(() => {
    const hub = isOutbound ? origin : destination;
    const setHub = isOutbound ? setFormattedOrigin : setFormattedDestination;
    const address = isOutbound ? destination : origin;
    const setAddress = isOutbound ? setFormattedDestination : setFormattedOrigin;

    const getHub = async () => {
      if (hub) {
        try {
          const { autoCompleteName } = await getHubByAddress(hub) || {};
          autoCompleteName && setHub(autoCompleteName);
        } catch (error) {
          console.error('Error fetching hub by address:', error);
        }
      }
    };

    const getAddress = async () => {
      if (address) {
        try {
          const googleAddress = await resolveGoogleAddress(address);
          setAddress(googleAddress.description);
        } catch (error) {
          console.error('Error resolving Google address:', error);
        }
      }
    };

    getHub();
    getAddress();
  }, [origin, destination, isOutbound, getHubByAddress, resolveGoogleAddress]);

  return (
    <div className={styles['journey-condensed']} onClick={onClick}>
      <div className={styles.frame}>
        <Icon />
        <div className={styles.group}>
          <div className={styles.caption}>{formattedOrigin}</div>
          <div className={styles['text-wrapper']}>{formattedDestination}</div>
        </div>
        <div className={styles['buttons-elements']}>
          <PenIcon className={styles['icon-l']} color="white" />
        </div>
      </div>
    </div>
  );
};
